import {
  BoxProps,
  Divider,
  Flex,
  RadioProps,
  useRadioGroup,
  UseRadioGroupProps,
} from "@chakra-ui/react";
import { config } from "config";
import * as React from "react";
import { isLastIndex } from "utils";

type RadioTabsGroupProps = UseRadioGroupProps &
  Omit<BoxProps, keyof UseRadioGroupProps>;

const RadioTabsGroup = React.forwardRef<HTMLDivElement, RadioTabsGroupProps>(
  (props, ref) => {
    // This component expects children of type RadioListItem,
    // otherwise it won't work as expected
    const {
      value: propValue,
      defaultValue,
      onChange,
      isDisabled,
      isFocusable,
      name,
      isNative,
      children,
      ...boxProps
    } = props;
    const childrenArray = React.Children.toArray(children);
    const { getRootProps, getRadioProps } = useRadioGroup({
      value: propValue,
      defaultValue,
      onChange,
      isDisabled,
      isFocusable,
      name,
      isNative,
    });
    const group = getRootProps();

    return (
      <Flex
        bg="gray.300"
        borderRadius="5px"
        p="2px"
        direction="row"
        spacing="2px"
        ref={ref}
        {...boxProps}
        {...group}
      >
        {childrenArray.map((child, index) => {
          if (React.isValidElement<RadioProps>(child)) {
            const {
              props: { value },
            } = child;
            const radio = getRadioProps({ value });
            return (
              <React.Fragment key={value}>
                {React.cloneElement(child, { ...radio })}
                {!isLastIndex(index, childrenArray) && (
                  <Divider
                    orientation="vertical"
                    color="gray.500"
                    h="calc(100% - 16px)"
                    my="8px"
                  />
                )}
              </React.Fragment>
            );
          }
          return child;
        })}
      </Flex>
    );
  }
);

if (config.isDev) {
  RadioTabsGroup.displayName = "RadioTabsGroup";
}

export type { RadioTabsGroupProps };
export { RadioTabsGroup };
